"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_2 = require("../../../../api/webAApi");
var PProgramsContentListCtl = /** @class */ (function (_super) {
    __extends(PProgramsContentListCtl, _super);
    function PProgramsContentListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_br_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_br_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.identity; });
        _this.dk_br_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_bd_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.dirName; });
        _this.dk_bf_filename = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fileName; });
        _this._errDialog = errDialog;
        return _this;
    }
    PProgramsContentListCtl.prototype.ResetData = function () {
        this.DATA = {
            pprograms: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    PProgramsContentListCtl.prototype.getPProgramItemById = function (id) {
        for (var i = 0; i < this.DATA.pprograms.length; i++) {
            if (this.DATA.pprograms[i].key === id) {
                return this.DATA.pprograms[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    PProgramsContentListCtl.prototype.getDirectoryItemByName = function (brand, dirName) {
        for (var i = 0; i < brand.directories.length; i++) {
            if (brand.directories[i].dirName === dirName) {
                return brand.directories[i];
            }
        }
        throw "object with name [" + dirName + "] not found !";
    };
    PProgramsContentListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCmsPProgramsContentDirectoryAllowedGet.exec({}, function (resp) {
            _this.DATA.pprograms = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.pprograms.length; i++) {
                var brandItem = {
                    key: resp.pprograms[i].key_uid,
                    identity: resp.pprograms[i].identity,
                    title: resp.pprograms[i].title,
                    directories: []
                };
                for (var j = 0; j < resp.pprograms[i].directories.length; j++) {
                    var dirItem = {
                        dirName: resp.pprograms[i].directories[j].name,
                        files: []
                    };
                    for (var k = 0; k < resp.pprograms[i].directories[j].files.length; k++) {
                        var fileItem = {
                            fileName: resp.pprograms[i].directories[j].files[k].filename
                        };
                        dirItem.files.push(fileItem);
                    }
                    brandItem.directories.push(dirItem);
                }
                _this.DATA.pprograms.push(brandItem);
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.IsFileExists = function (pprogram, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentFileExists.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            if (onDone) {
                onDone(resp.is_exists);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.CreateDirectory = function (pprogram, dirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentDirectoryCreate.exec({
            pprogram_id: pprogram.key,
            dir_name: dirName
        }, function (resp) {
            pprogram.directories.push({
                dirName: dirName,
                files: [],
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.RenameDirectory = function (pprogram, oldDirName, newDirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentDirectoryRename.exec({
            pprogram_id: pprogram.key,
            dir_name: oldDirName,
            dir_new_name: newDirName
        }, function (resp) {
            for (var i = 0; i < pprogram.directories.length; i++) {
                if (pprogram.directories[i].dirName === oldDirName) {
                    pprogram.directories[i].dirName = newDirName;
                }
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.DeleteDirectory = function (pprogram, dirName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentDirectoryDelete.exec({
            pprogram_id: pprogram.key,
            dir_name: dirName
        }, function (resp) {
            _this.RemoveDirectoryItem(pprogram, dirName);
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.RemoveDirectoryItem = function (pprogram, dirName) {
        var i_idx = -1;
        for (var i = 0; i < pprogram.directories.length; i++) {
            if (pprogram.directories[i].dirName === dirName) {
                i_idx = i;
            }
        }
        var rest = pprogram.directories.slice(i_idx + 1);
        pprogram.directories.length = i_idx;
        return pprogram.directories.push.apply(pprogram.directories, rest);
    };
    PProgramsContentListCtl.prototype.UploadFileAll = function (pprogram, dir, fName, fBase64, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentFileUploadAll.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: fName,
            data_base64: fBase64
        }, function (resp) {
            dir.files.push({ fileName: fName });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.DoCmsPProgramContentFileUploadReset = function (pprogram, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentFileUploadReset.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            dir.files.push({ fileName: fName });
            //  this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.DoCmsPProgramContentFileUploadAppend = function (pprogram, dir, fName, fBase64, onDone) {
        var _this = this;
        webAApi_2.DoCmsPProgramContentFileUploadAppend.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: fName,
            data_base64: fBase64
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.RenameFile = function (pprogram, dir, oldFileName, newFileName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentFileRename.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: oldFileName,
            file_new_name: newFileName
        }, function (resp) {
            for (var i = 0; i < dir.files.length; i++) {
                if (dir.files[i].fileName === oldFileName) {
                    dir.files[i].fileName = newFileName;
                }
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PProgramsContentListCtl.prototype.RemoveFileItem = function (dir, fName) {
        var i_idx = -1;
        for (var i = 0; i < dir.files.length; i++) {
            if (dir.files[i].fileName === fName) {
                i_idx = i;
            }
        }
        var rest = dir.files.slice(i_idx + 1);
        dir.files.length = i_idx;
        return dir.files.push.apply(dir.files, rest);
    };
    PProgramsContentListCtl.prototype.DeleteFile = function (pprogram, dir, fName, onDone) {
        var _this = this;
        webAApi_1.DoCmsPProgramContentFileDelete.exec({
            pprogram_id: pprogram.key,
            dir_name: dir.dirName,
            file_name: fName
        }, function (resp) {
            _this.RemoveFileItem(dir, fName);
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PProgramsContentListCtl;
}(BaseController_1.BaseController));
exports.PProgramsContentListCtl = PProgramsContentListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ctl/PartnersContentListCtl.ts
// module id = 1003
// module chunks = 0